export default __webpack_public_path__ + "static/logo-400-a805d12e448cbb9bbfd41a7319d394df.png";